import { Locale } from "@kizmann/pico-js";
import { CrudIndex } from "#pub/crud/index.js";

export default {

    extends: CrudIndex,

    title: Locale.trans('All messages'),

    name: 'MessageIndex',

    crud: {
        index: '/api/message',
        delete: '/api/message/delete',
        show: '/api/message/:id',
        create: '/api/message/create',
        update: '/api/message/:id',
    },

    urls: {
        index: 'message.index',
        item: 'message.item'
    },

    search: [
        'channel', 'body.message'
    ],

    filter: [
        'token'
    ],

    columns: [
        {
            type: 'string',
            prop: 'id',
            label: Locale.trans('ID'),
            visible: false,
            minWidth: 0,
            fixedWidth: 320,
        },
        {
            type: 'channel',
            prop: 'channel',
            label: Locale.trans('Channel'),
            sort: true,
            minWidth: 0,
            fixedWidth: 120,
        },
        {
            type: 'string',
            prop: 'body.type',
            label: Locale.trans('Type'),
            minWidth: 0,
            fixedWidth: 120,
        },
        {
            type: 'string',
            prop: 'body.message',
            label: Locale.trans('Message'),
            width: '70%',
        },
        {
            type: 'boolean',
            prop: 'is_read',
            label: Locale.trans('Read'),
            sort: true,
            minWidth: 90,
            fixedWidth: 90,
        },
        {
            type: 'client',
            prop: 'token_id',
            label: Locale.trans('Client'),
            sort: true,
            width: '30%',
        },
        {
            type: 'datetime',
            prop: 'updated_at',
            label: Locale.trans('Updated'),
            visible: false,
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
        {
            type: 'datetime',
            prop: 'created_at',
            label: Locale.trans('Created'),
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
    ],

    renderForm()
    {
        return (<MessageForm />);
    }

}